module.exports = __webpack_public_path__ + "static/media/cotyBanner-tablet-411x93@2x.5dec35e4.jpg";